"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useData = void 0;
const react_redux_1 = require("react-redux");
const accounts_1 = require("companion-app-components/flux/accounts");
const categories_1 = require("companion-app-components/flux/categories");
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
const root_ui_1 = require("companion-app-components/flux/root-ui");
const account_groups_1 = require("companion-app-components/flux/account-groups");
const useData = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    return {
        categoriesById: (0, react_redux_1.useSelector)((state) => categories_1.categoriesSelectors.getCategoriesById(state)),
        accountsById: (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getAccountsById(state)),
        sharedAccounts: (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getEntityShareAccountsById(state)),
        isEntityGroupEnabled: (0, react_redux_1.useSelector)((state) => account_groups_1.accountGroupsSelectors.isAccountGroupEnabled(state)),
        dispatchDeleteScheduledTransactionAction: (data) => dispatch(scheduled_transactions_1.scheduledTransactionsActions.deleteScheduledTransaction(data, { undo: { userMessage: 'Recurring transaction deleted.' } })),
        dispatchMakeDialog: (data) => dispatch(root_ui_1.rootUiActions.createDialog(root_ui_1.rootUiTypes.mkRootUiData(data))),
    };
};
exports.useData = useData;
